'use client'

import { ProfileLinkDialog } from '@/app/profile-manager/settings/connected-accounts/profile-link-dialog'
import { ProfileLinkRow } from '@/app/profile-manager/settings/connected-accounts/profile-link-row'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { profileLinkServices } from '@/resources/profile-link-services'
import { PlusIcon } from 'lucide-react'
import { useRouter } from 'next/navigation'
import { useState } from 'react'

export function UnofficialAccounts({ profileLinks }) {
  const router = useRouter()
  const [dialogOpen, setDialogOpen] = useState(false)
  const [selectedProfileLink, setSelectedProfileLink] = useState(null)
  const usedServices = profileLinks.map((profileLink) => profileLink.service)
  const allServicesUsed = profileLinkServices.every((service) =>
    usedServices.includes(service.id),
  )

  function handleAdd() {
    setSelectedProfileLink(null)
    setDialogOpen(true)
  }

  function handleEdit(profileLink) {
    setSelectedProfileLink(profileLink)
    setDialogOpen(true)
  }

  function handleOpenChange(open) {
    setDialogOpen(open)
    if (!open) setSelectedProfileLink(null)
  }

  return (
    <>
      <Card className="bg-transparent! border-none p-0 shadow-none">
        <CardHeader className="flex-row items-start justify-between gap-4 space-y-0 px-0 pt-0">
          <div>
            <CardTitle className="text-h-4 font-semibold text-white">
              External Links
            </CardTitle>
            <CardDescription className="mt-1 text-p-1 text-neutral-blue-500">
              Choose which external links appear on your profile.
            </CardDescription>
          </div>
          <Button
            type="button"
            variant="success"
            size="sm"
            onClick={handleAdd}
            disabled={allServicesUsed}
          >
            <PlusIcon className="mr-1 h-4 w-4" />
            Add
          </Button>
        </CardHeader>

        <CardContent className="px-0">
          {profileLinks.length ? (
            <ul>
              {profileLinks.map((profileLink) => (
                <ProfileLinkRow
                  key={profileLink.id}
                  profileLink={profileLink}
                  onEdit={handleEdit}
                  onChanged={() => router.refresh()}
                />
              ))}
            </ul>
          ) : (
            <div className="rounded-sm border border-dashed border-neutral-blue-700 bg-neutral-blue-800/50 p-6 text-p-1 text-neutral-blue-400">
              No external links added yet.
            </div>
          )}
        </CardContent>
      </Card>

      <ProfileLinkDialog
        open={dialogOpen}
        onOpenChange={handleOpenChange}
        profileLink={selectedProfileLink}
        unavailableServices={usedServices}
        onSaved={() => router.refresh()}
      />
    </>
  )
}
